import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Select from "react-select";
import Sidebar from '../Components/Sidebar';
import Header from '../Components/Header';
import "../assets/css/suggestPairsPage.css";
import { LoaderComponent } from '../Components/UiComponent';
import { EditTrendingPairModal } from '../Modals/TrendingPairModel';
import { initSocket } from "../utils/socketClient";
import { updateTrendingSuggestedPairs } from '../actions/currency';
import toast from "react-hot-toast";
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const stylesgraybg = {
  option: (styles, { isFocused, isSelected, isHovered }) => ({
    ...styles,
    backgroundColor: isHovered || isSelected || isFocused ? "#44D7B6" : "#000",
    color: isHovered || isSelected || isFocused ? "#fff" : "#fff",
    fontSize: "13px",
    cursor: "pointer",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "43px",
    padding: "0px 10px",
    backgroundColor: "transparent",
    border: "none",
    fontSize: "13px",
  }),
  control: (provided) => ({
    ...provided,
    height: "40px",
    borderRadius: 10,
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
    boxShadow: "none",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "40px",
    position: "absolute",
    right: 0,
    top: 0,
    padding: "0px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#ffffff",
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    width: "100%",
    borderRadius: 5,
    background: "transparent",
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: "#fff",
  }),
};

const socket = initSocket();

export default function TrendingPair() {
  const history = useHistory();

  const [suggestedPairs, setSuggestedPairs] = useState([]);
  const [filteredPairs, setFilteredPairs] = useState([]);
  const [isLoader, setIsLoader] = useState(true);
  const [showEditToken, setShowEditToken] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);

  const handleCloseEditToken = () => setShowEditToken(false);

  useEffect(() => {
    setIsLoader(true);

    socket.on("trendingPairs", ({ trending }) => {
      setSuggestedPairs(trending || []);
      setFilteredPairs(trending || []);
      setIsLoader(false);
    });

    return () => {
      socket.off("trendingPairs");
      setIsLoader(false);
    };
  }, [socket]);

  const handleChange = async (e, pair) => {
    try {
      const { name, type, checked } = e.target;
      const updatedValue = type === 'checkbox' ? checked : e.target.value;

      const updatedPair = { ...pair, [name]: updatedValue };
      const { status } = await updateTrendingSuggestedPairs(updatedPair);

      if (status === "success") toast.success("Pair updated successfully!");
      else toast.error("Pair update failed.");
    } catch (err) {
      console.error("handleChange error:", err);
    }
  };

  const selectOptions = suggestedPairs.map((pair) => ({
    label: `${pair.tokenIn?.symbol} / ${pair.tokenOut?.symbol}`,
    value: pair.tokenIn?.symbol,
  }));

  const handleFilterChange = (selectedOption) => {
    setSelectedToken(selectedOption);

    if (!selectedOption) {
      setFilteredPairs(suggestedPairs);
      return;
    }

    const token = selectedOption.value.toLowerCase();
    const filtered = suggestedPairs.filter(
      (pair) =>
        pair.tokenIn?.symbol?.toLowerCase().includes(token) ||
        pair.tokenOut?.symbol?.toLowerCase().includes(token)
    );

    setFilteredPairs(filtered);
  };

  const formatPriceDisplay = (priceStr) => {
    if (typeof priceStr === 'string' && priceStr.startsWith('0.0-')) {
      const parts = priceStr.split('-');
      const prefix = parts[0];
      const zeroCount = parts[1];
      const significant = parts[2];
      return (
        <>
          {prefix}
          <sup style={{ fontSize: '0.6em', verticalAlign: 'super' }}>{zeroCount}</sup>
          {significant.slice(0, 5)}
        </>
      );
    }
    const num = Number(priceStr);
    return num ? `$${num.toFixed(6)}` : '--';
  };

  const toFixedNumber = (x) => {
    if (Math.abs(x) < 1.0) {
      var e = parseInt(x.toString().split("e-")[1]);
      if (e) {
        x *= Math.pow(10, e - 1);
        x = "0." + new Array(e).join("0") + x.toString().substring(2);
      }
    } else {
      var e = parseInt(x.toString().split("+")[1]);
      if (e > 20) {
        e -= 20;
        x /= Math.pow(10, e);
        x += new Array(e + 1).join("0");
      }
    }
    return x.toString();
  };

  const formatLiquidity = (value) => {
    const num = Number(value);
    const convert = toFixedNumber(num);

    if (convert >= 1_0000) return `${(convert / 1_0000).toFixed(2)} B`;
    if (convert >= 1_000) return `${(convert / 1_000).toFixed(2)} M`;
    if (convert >= 10) return `${(convert / 10).toFixed(2)} K`;
    return convert;
  };

  return (
    <Container fluid className="common_bg position-relative">
      <div className="liner"></div>
      <Row>
        <Col xl={2} lg={0} className="p-0 d-none d-xl-block">
          <Sidebar />
        </Col>

        <Col xl={10} lg={12}>
          <Header title={"Trending Pairs"} />
          <div className='suggestPairsPage' data-page-animation>
            <div className='suggestPairsHeader py-4 px-2 d-flex align-items-end justify-content-end flex-wrap gap-3'>
              <div className='d-flex gap-3 flex-wrap'>
                <div className='searchBoxContainer'>
                  <label>Filter</label>
                  <Select
                    className="searchBox customselect"
                    options={selectOptions}
                    styles={stylesgraybg}
                    theme="dark"
                    placeholder="Select Token Pair"
                    isLoading={isLoader}
                    value={selectedToken}
                    onChange={handleFilterChange}
                    isClearable
                    // menuIsOpen
                  />
                </div>
              </div>
              {/* <button className='orange_small_primary'>Add</button> */}
            </div>

            <div className="scrollBarContainer">
              <div className='suggestPairsCardWrapper'>
                {filteredPairs.map((pair, index) => (
                  <div key={index} className='suggectionCard landingTemplate'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div className='d-flex align-items-center gap-1'>
                        <h3 className='walletNameText'>
                          {pair.tokenIn?.symbol} / {pair.tokenOut?.symbol}
                        </h3>
                      </div>
                    </div>

                    <div className='d-flex gap-2 align-items-center'>
                      <h3 className='amtText'>{formatPriceDisplay(pair.receivedBackHuman)}</h3>
                    </div>

                    <div>Profit Percentage: <span className='badgeTag'>{pair.profitPct.toFixed(4)}%</span></div>
                    <div>Profit: <span className='badgeTag'>{pair.profitAmount.toFixed(4)}</span></div>

                    <div className='d-flex justify-content-between'>
                      <div className='statusValues'>
                        <p>
                          <img src={require("../assets/images/bitcoin.svg").default} alt="btc" />
                          Liquidity: {formatLiquidity(pair.sellDetails.liquidity24hrs)}
                        </p>
                      </div>
                    </div>

                    <div className='d-flex align-items-center justify-content-between'>
                      <h4 className='fs-6 m-0'>Show / Hide</h4>
                      <div className="showAndHideToggle">
                        <input
                          type="checkbox"
                          name="isAdminApproved"
                          checked={pair.isAdminApproved}
                          onChange={(e) => handleChange(e, pair)}
                        />
                        <label></label>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {isLoader && <LoaderComponent />}
              {!isLoader && filteredPairs.length === 0 && (
                <p className='noDataText'>No Data Found !</p>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <EditTrendingPairModal
        show={showEditToken}
        record={editRecord}
        handleClose={handleCloseEditToken}
      />
    </Container>
  );
}
